import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  /* background-color: #fff; */
    &::-webkit-scrollbar {
    display: none;
  }
`;
